import styled from 'styled-components';

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	width: 100%;
`;

export const CardsContainer = styled.div`
	display: flex;
	${(props) =>
		props.direction === 'column'
			? 'flex-direction: column; justify-content: space-between; align-items: center;'
			: 'flex-direction: row; justify-content: center; align-items: stretch;'};
	width: 100%;
	gap: 20px;
`;

export const TitleContainer = styled.div`
	display: flex;
	justify-content: left;
	align-items: start;
	margin-bottom: 10px;
`;

export const Input = styled.input`
	margin-top: 7px;
	min-width: 30px;
	width: 10%;
`;

export const Image = styled.img`
	width: 100%;
	margin-right: 15px;
`;

export const Description = styled.p`
	text-align: left;
	margin: 0;
	padding-block: 8px;
	padding-inline: 20px;
`;

export const InfoCard = styled.div`
	display: flex;
	${(props) =>
		props.cardType === 'horizontal'
			? 'flex-direction: row; justify-content: space-between; align-items: start;'
			: 'flex-direction: column; justify-content: left; align-items: center;'};
	padding-top: 15px;
	cursor: pointer;
	border-radius: 2px;
	border: ${(props) => (props.selected ? '2px solid #1890FF' : '2px solid #e6e8e8')};
	transition: border ease 0.2s;
	min-height: 100%;

	${TitleContainer} {
		width: ${(props) => (props.cardType === 'horizontal' ? '40%' : '100%')};
	}

	${Description} {
		width: ${(props) => (props.cardType === 'horizontal' ? '60%' : '100%')};
	}
`;
